export default __webpack_public_path__ + "static/media/rock.29441226.png";